import { gql } from 'graphql-request'

export namespace FieldHistoryLogQueries {
  export const QUERY_KEY = 'getFieldHistoryLogs'

  export namespace GET {
    export type Response = { fieldHistoryLogs: FieldHistoryLog[] | null }
  }
  export function getFieldHistoryLogs() {
    return gql`
      query getFieldHistoryLogs($record: Record) {
        fieldHistoryLogs(record: $record) {
          id
          modifiedAt
          fieldChanges
          operation
          user {
            fullName
          }
        }
      }
    `
  }
}

export interface FieldHistoryLog {
  fieldChanges: FieldChange[] | null
  id: number
  modifiedAt: string
  operation: string | null
  user: {
    fullName: string
  }
}

export enum RecordType {
  HOME_QUALITY_CHECKS = 'HomeQualityChecks',
  LEADS = 'Leads',
  POTENTIAL_BOOKINGS = 'PotentialBookings',
  SCHEDULED_COMMUNICATIONS = 'ScheduledCommunications',
  SCHEDULED_COMMUNICATION_TEMPLATES = 'ScheduledCommunicationTemplates',
  SCHEDULED_COMMUNICATION_TYPES = 'ScheduledCommunicationTypes',
  TICKETS = 'Tickets',
}

export interface FieldChange {
  field_name: string
  new: string
  old: string
}
